import React, { Component, Fragment } from 'react'
import { CollectionEditForm } from 'components'

import IconButton from '@material-ui/core/IconButton'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import { authorizedLink } from 'utils'


export class PartnersForm extends Component{

  constructor(properties) {
    super(properties)

    this.attributes =[
      {name: 'name',        label: 'Name',        required: true},
      {name: 'logo',        label: 'Logo',        required: true,
                            renderer: this.logoRenderer, input: this.logoInput,
                            validator: this.fileUploadValidator},
      {name: 'websiteUrl',  label: 'Website URL', required: false}
    ]
  }

  fileUploadValidator = (attributeName, required, form) => {
    const errors = {}
    const attributeValue = form.attribute(`${attributeName}FileName`) || form.attribute(attributeName)
    if(required && !attributeValue) {
      errors[attributeName] = 'Must be present'
    }
    return errors
  }

  logoInput = (element, form) => {
    return (
      <form.FileUploadField key='logo' label='Logo' attribute='logo' alt='image' acceptedTypes=".jpg, .gif, .png"/>
    )
  }

  logoRenderer = ({uuid, name, description, logo, logoUrls, logoFileName}) => {
    const original = (logoUrls) ? logoUrls.original : null
    let fileName = logoFileName

    if(logo) {
      fileName  = logo.name
    }
    return (
      <Fragment>
        {/** no refferer**/}
        { !uuid && !logo &&
          <a target="_blank" rel="noopener noreferrer" href={authorizedLink(original)}>
            <IconButton>
              <DownloadIcon/>
            </IconButton>
          </a>
        }
        {fileName}
      </Fragment>
    )
  }

  render = () =>
    <CollectionEditForm elements={ this.props.partners } attributes={ this.attributes } onElementsChange={ this.props.onPartnersChange }/>
}

export default PartnersForm